<div class="row">
  <div class="col">
    <p class="message-text">{{ message }}</p>
  </div>
</div>
<div class="d-flex">
  <div class="flex-fill"></div>
  <button mat-raised-button color="primary" (click)="dismiss()">{{ 'Foundation.OK' | translate }}</button>
</div>
